<template>
    <div class="com-header">
        <!-- top -->
        <div class="top">
            <img src="@/assets/images/logo.png" height="30">
            <svg class="menu-btn" aria-hidden="true" @click="showPop = true">
              <use xlink:href="#icon-menulines" />
            </svg>
        </div>
        <van-popup
            v-model:show="showPop"
            closeable
            position="right"
            :style="{ width: '80%', height: '100%' }"
        >
            <van-collapse class="com-menu" v-model="activeMenu">
                <van-collapse-item :title="item.name" :name="item.path" v-for="item in menu" :key="item.path">
                    <router-link
                        :to="`${item.path}/${subMenu.path}`"
                        v-for="subMenu in item.children"
                        :key="`${item.path}/${subMenu.path}`"
                        :class="getCurrentRoute(`${item.path}/${subMenu.path}`)"
                    >
                        {{ subMenu.name }}
                    </router-link>
                    <!-- <router-link to="/futian/index" :class="getCurrentRoute('/futian/')">历代祖师</router-link> -->
                </van-collapse-item>
                <van-collapse-item title="联系我们" name="contact" class="contact">
                    <p>通讯地址</p>
                    <p>浙江省 杭州市 西湖区 南山路56号</p>
                    <p>邮编310000</p>
                    <br>
                    <p>客堂电话</p>
                    <p>
                        <a href="tel:0571-87995600">0571-87995600</a>
                    </p>
                    <br>
                    <p>在线联络</p>
                    <p>
                        <svg class="wx" aria-hidden="true" @click="toChart">
                            <use xlink:href="#icon-weixin" />
                        </svg>
                    </p>
                </van-collapse-item>
                <router-link to="/order/index" :class="getCurrentRoute('/order/index')" class="index" v-if="userInfo.status == 1">我的订单</router-link>
            </van-collapse>
        </van-popup>
        <!-- // top -->
    </div>
</template>

<script>
    import menu from '@/assets/js/menu'
    import { getUserInfo } from '@/utils/auth'
    import { CHAT_URL } from '@/config'
    export default {
        data () {
            return {
                menu: menu.slice(1),
                showPop: false,
                // 当前展开菜单
                activeMenu: [],
                userInfo: getUserInfo()
            }
        },
        watch: {
            '$route' () {
                // console.log(this.$route.fullPath)
                // console.log(this.$route.matched[0])
                // console.log(this.$route.fullPath.indexOf(this.$route.matched[0].path))
                this.showPop = false
                // this.activeMenu = [this.$route.matched[0].path]
            }
        },
        mounted () {
            this.activeMenu = [this.$route.matched[0].path]
        },
        methods: {
            // 跳转聊天
            toChart () {
              window.location.href = CHAT_URL
            },
            // 当前路由
            getCurrentRoute (path) {
                return (this.$route.matched[0].path + '/' + (this.$route.meta.parentMenu || '')) == path ? 'current' : ''
            }
        },
        components: {
            
        }
    }
</script>

<style lang="less">
    .com-header {
        .top {
            // height: 6.666667rem;
            padding: 1.111111rem;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, .3);
            z-index: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .menu-btn {
                width: 20px;
                height: 20px;
            }
        }
        .van-popup__close-icon {
            width: 6px;
            height: 6px;
            border: 6px solid #F0D48F;
            border-radius: 100%;
            &:before {
                display: none;
            }
        }
    }
</style>
